import { render } from "./GiftAddView.vue?vue&type=template&id=abc73018"
import script from "./GiftAddView.vue?vue&type=script&lang=js"
export * from "./GiftAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__